'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkPeaceOfMindBlock.module.css';

export function DevlinkPeaceOfMindBlock({
  as: _Component = _Builtin.Section,
  image = 'https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/65f0e7930cb8628fba598720_lady-on-couch-with-phone-4-cropped%20(1).jpg',
}) {
  return (
    <_Component
      className={_utils.cx(_styles, 'ht-featured-product-section')}
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'ht-featured-content-wrapper')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'ht-featured-content-container')} tag="div">
          <_Builtin.Image
            className={_utils.cx(_styles, 'ht-featured-pom-badge')}
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/6616c736d5f8cb2c7df814ad_peace-of-mind-badge%201.svg"
          />
          <_Builtin.Block className={_utils.cx(_styles, 'ht-poc-guarantee-image')} tag="div">
            <_Builtin.Image className={_utils.cx(_styles, 'ht-inner-img')} loading="lazy" width="auto" height="auto" alt="" src={image} />
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, 'ht-feauterd-content')} tag="div">
            <_Builtin.Heading tag="h2">
              {'Your peace of mind '}
              <br />
              {'is '}
              <_Builtin.Span className={_utils.cx(_styles, 'txt-teal500')}>{'our mission'}</_Builtin.Span>
            </_Builtin.Heading>
            <_Builtin.Block className={_utils.cx(_styles, 'small-1')} tag="div" />
            <_Builtin.Paragraph className={_utils.cx(_styles, 'txt-body-lg')}>
              {
                "We're committed to your complete satisfaction with our service. If you're not 100% happy, we'll do whatever it takes to make it right."
              }
            </_Builtin.Paragraph>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
